<script setup lang="ts">
import { classNames } from '@afinius/utilities/class-names';

interface Props {
  size?: 'xs' | 'sm' | 'md' | 'lg';
  initials?: string;
  avatar?: string;
  outline?: 'light' | 'dark';
  isLight?: boolean;
}

withDefaults(defineProps<Props>(), {
  size: 'md',
  initials: '',
  avatar: undefined,
  outline: 'light',
  isLight: false,
});
</script>

<template>
  <div class="avatar" :class="classNames({ size, outline, isLight })">
    <img v-if="avatar" class="avatar__image" :src="avatar" :alt="initials" />
    <template v-else-if="initials">{{ initials }}</template>
    <slot v-else />
  </div>
</template>

<style lang="scss" scoped>
@use './Avatar.scss';
</style>
